<template>
    <div class="window-container" :id="id" :style="{fontFamily:fontFamily, marginTop:'35vh'}">
        <img
            style="marginLeft:-150px;"
            :src="getImgUrl(imgfile)"
            height="auto"
            width="1050px"
            alt="character-panel-bg"
        />

        <!-- ----------- TEXT ----------- 
        :style="{marginTop:(yoffset+50 || 160)+'px'}"
        -->
        <div
            :style="{
                    marginTop:(txtTop || -550)+'px',
                    marginLeft:(txtLeft || -80)+'px',
                    color: 'black',
                    width: (textWidth || '520') + 'px'
                }">
            <div :style="{  fontSize: '40px', 
                            color:fontColor || '#000',
                            backgroundColor:fontColor === '#6F6' ?  '#000' : 'transparent', //accessibility hack
                        }">{{title}}</div>
            <br/>
            <div :style="{
                            fontSize:(fontSize || 20)+'px', 
                            color:fontColor || '#000',
                            backgroundColor:fontColor === '#6F6' ?  '#000' : 'transparent', //accessibility hack
                        }" v-html="txt"></div>
            <img 
                    v-if="imgchar"
                    :src="getImgUrl2(imgchar)"
                    :style="{
                        width:'150px',
                        height:'auto',
                        position:'absolute',
                        top: '50px',
                        left: (imgcharx || '-50')+'px'
                    }"> 
        </div>

        <div v-if="gameScale > 0">
            <div
                class="start-container"
                :id="'game_'+id"
                :style="{
                        transform:'translate('+(gameLeft)+'px, '+(gameTop)+'px) scale('+gameScale+', '+gameScale+')',
                        color: 'black',
                        width: (textWidth || '520') + 'px'
                    }">
            </div>

            <div class="skipButton"
                :id="'game_skip_'+id"
                @click="skipGame()">
                <img src="../assets/skip-btn.png" alt="skip-btn">
            </div>

 <!--  -->
 
            <!--  
        <img
            style="marginLeft:-150px;"
            :style="{
                marginTop:'35vh'
            }"
            :src="getImgUrl('skip-btn')"
            height="auto"
            width="1050px"
            alt="character-panel-bg"
        />
-->
            <!-- ----------- START BUTTON ----------- -->
                
            <div 
                v-if="!gameActive"
                class="start-container"
                :id="'startButton_'+id"
                :style="{
                    transform: 'translate('+txtLeft+'px, '+(txtTop)+'px)',
                    fontFamily:fontFamily,
                    color:fontColor || '#000',
                    backgroundColor:fontColor === '#6F6' ?  '#000' : 'transparent', //accessibility hack
                    width: (textWidth || '520') + 'px',
                    }"
                @click="startGame(id, gameId)">
                <div class="start-instr"
                    :style="{   fontSize:(fontSize || 20)+'px', 
                                color:fontColor || '#000',
                                backgroundColor:fontColor === '#6F6' ?  '#000' : 'transparent', //accessibility hack
                            }" 
                    v-html="instructionsTxt">
                </div>
                <h3 class="start">Click to PLAY</h3>
                
            </div>

            <!-- ----------- HIDDEN TXT ----------- -->

            <div
                class="start-container"
                :id="'hiddenText_'+id"
                :style="{
                    transform: 'translate('+txtLeft+'px, '+txtTop+'px)',
                    fontFamily:fontFamily,
                    color:fontColor || '#000',
                    backgroundColor:fontColor === '#6F6' ?  '#000' : 'transparent', //accessibility hack
                    display:'none',
                    width: (textWidth || '520') + 'px',
                }">
                <div class="start-instr"
                    :style="{   fontSize:(fontSize || 20)+'px', 
                                color:fontColor || '#000',
                                backgroundColor:fontColor === '#6F6' ?  '#000' : 'transparent', //accessibility hack
                            }" 
                    v-html="hiddenTxt">
                </div>
                <div class="start-instr"
                    :style="{marginTop:'30px'}"
                    @click="startGame(id, gameId)">
                    <h3 class="start again" style='margin:0'>Play Again</h3>
                </div>
                
            </div>

        </div>
    </div>
</template>

<script>
    export default {
        name : 'Panel',
        props : {
            id: String,
            pos: Number,
            width: Number,
            startTime: Number,
            gameActive: Number,
            imgfile: String,
            bgimgfile: String,
            imgchar: String,
            imgcharx: Number,
            yoffset: Number,
            txt: String,
            hiddenTxt: String,
            instructionsTxt: String,
            title: String,
            txtTop: String,
            txtLeft: String,
            fontFamily: String,
            fontColor: String,
            fontSize: String,
            textWidth: String,

            gameId: String,
            gameLeft: String,
            gameTop: String,
            gameScale: String,

            slider: String

        },
        data : function () {
            return {
                pos2: 0, buttonScale: 0,
                //sceenHeight:getScreenHeight(),
            }
        },
        methods : {
            startGame: function (elId, gameId) {
                try {
                    if (window.lastId){
                        document
                            .getElementById('game_' + window.lastId)
                            .removeChild(window['game' + window.lastId]);
                            window.lastId = null;
                    }
                } catch(e){}
                window['game' + this.id] = null

                document
                    .getElementById('hiddenText_' + this.id).style.display = "none";

                document
                    .getElementById('game_skip_' + this.id).style.display = "block";

                document
                    .getElementById('startButton_' + this.id)
                    .style
                    .display = "none";
                
                if (Math.floor(this.slider) === 1 || Math.floor(this.slider) === 2){
                    this.gameActive = 1;

                } else {
                    disableScroll();
                    this.id = elId;
                    if (!window['game' + this.id]) {
                           
                        let url, style;
                        switch (Math.floor(gameId)){
                            case 1 : 
                                url = "./slider_puzzle/index.html"; 
                                style = "background-color: transparent; width: 336px; height: 336px; margin-top: 9px; border: 0px; margin-left: -77px";
                                break;
                            case 2 : 
                                url = "./slider_puzzle_2/index.html"; 
                                style = "background-color: transparent; width: 336px; height: 336px; margin-top: -10px; border: 0px; margin-left: -175px";
                                break;
                            default : 
                                url = "./game1.html?id="+Math.floor(gameId);
                                style = "background-color: transparent; width: 800px; height: 575px; margin-top: -97px; border:0;"
                        }

                        window['game' + this.id] = document.createElement('iframe');
                        window['game' + this.id].style = style;
                        window['game' + this.id].src = url+"?cache="+Math.floor(Math.random()*99999999);
                        window['game' + this.id].title = 'embedded game'; // accessilbility

                        document.getElementById('game_' + this.id).appendChild(window['game' + this.id]);
                        window.lastId = this.id;

                        function bindEvent(element, eventName, eventHandler) {
                            if (element.addEventListener) {
                                element.addEventListener(eventName, eventHandler, false);
                            } else if (element.attachEvent) {
                                element.attachEvent('on' + eventName, eventHandler);
                            }
                        }

                        // Listen to messages from parent window
                        bindEvent(window, 'message', function (e) {
                            //game complete
                            // alert(e.data)
                            // alert(typeof e.data)
                            const score = Math.floor(e.data);
                            if (typeof e.data === 'number'){
                                enableScroll();
                                document
                                    .getElementById('game_' + window.lastId)
                                    .removeChild(window['game' + window.lastId]);
                                document
                                    .getElementById('hiddenText_' + window.lastId).style.display = "block";
                                document
                                    .getElementById('game_skip_' + window.lastId).style.display = "none";
                            }
                        });
                    }
                }
            },

            skipGame() {
                //game complete
                enableScroll();
                document
                    .getElementById('game_' + window.lastId)
                    .removeChild(window['game' + window.lastId]);
                document
                    .getElementById('hiddenText_' + window.lastId).style.display = "block";
                document
                    .getElementById('game_skip_' + window.lastId).style.display = "none";
            },

            getImgUrl(pet) {
                var images = require.context('../assets/scene/', false, /\.png$/)
                return images('./' + pet + ".png")
            },

            getImgUrl2(pet) {
                var images = require.context('../assets/faces/', false, /\.png$/)
                return images('./' + pet + ".png")
            },

        },

        created : function () {
            window.requestAnimationFrame(step.bind(this));
        }
    }

    // left: 37, up: 38, right: 39, down: 40, spacebar: 32, pageup: 33, pagedown:
    // 34, end: 35, home: 36
    var keys = {
        37: 1,
        38: 1,
        39: 1,
        40: 1,
        32: 1,
        33: 1,
        34: 1,
        35: 1,
        36: 1
    };

    function preventDefault(e) {
        e = e || window.event;
        if (e.preventDefault) 
            e.preventDefault();
        e.returnValue = false;
    }

    function preventDefaultForScrollKeys(e) {
        if (keys[e.keyCode]) {
            preventDefault(e);
            return false;
        }
    }

    function disableScroll() {
        if (window.addEventListener) // older FF
            // window.addEventListener('DOMMouseScroll', preventDefault, false);
            // document.addEventListener('wheel', preventDefault, {passive: false}); // Disable scrolling in Chrome
            // window.onwheel = preventDefault; // modern standard
            // window.onmousewheel = document.onmousewheel = preventDefault; // older browsers, IE
            window.ontouchmove = preventDefault; // mobile
            document.onkeydown = preventDefaultForScrollKeys;
    }

    function enableScroll() {
        if (window.removeEventListener) 
            window.removeEventListener('DOMMouseScroll', preventDefault, false);
        document.removeEventListener('wheel', preventDefault, {passive: false}); // Enable scrolling in Chrome
        window.onmousewheel = document.onmousewheel = null;
        window.onwheel = null;
        window.ontouchmove = null;
        document.onkeydown = null;
    }

    function step() {
        var scrolly = this.pos;
        var width = this.width;
        var WIN1_IN_START = parseInt(this.startTime);
        var WIN1_IN_TIME = (width / 2 + 450);
        var WIN1_DURATION = 2500;
        var panelScale = this.width

        var p2t;
        if (scrolly < WIN1_IN_START) { // hide
            p2t = width + 500;
        } else if (scrolly > WIN1_IN_START && scrolly < WIN1_IN_START + WIN1_IN_TIME) { // scroll-in
            p2t = width + WIN1_IN_START - scrolly;
            let sc = (scrolly - WIN1_IN_START) / WIN1_IN_TIME;

        } else if (scrolly > WIN1_IN_START + WIN1_IN_TIME && scrolly < WIN1_IN_START + WIN1_IN_TIME + WIN1_DURATION) {
            p2t = width - WIN1_IN_TIME;

        } else if (scrolly > WIN1_IN_START + WIN1_IN_TIME + WIN1_DURATION) {
            p2t = width + WIN1_IN_START + WIN1_DURATION - scrolly;
            let sc = (scrolly - (WIN1_IN_START + WIN1_IN_TIME)) / WIN1_DURATION;
            sc = 1 + (1 - sc);

        } else {
            p2t = -500;
        }
        if (!p2t) {
            p2t = 0;
        }

        const sceenHeight = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;
        // let heightPerc = (sceenHeight / 800) + 0.2;
        let heightPerc = (sceenHeight / 1000) + 0.2;
        // if (heightPerc > 1) heightPerc = 1;
        
        this.pos2 += ((p2t - this.pos2) / 15);
        window.requestAnimationFrame(step.bind(this));
        document
            .getElementById(this.id)
            .style
            .transform = "translate3d(" + this.pos2 + "px, -50px, 0) scale(" + heightPerc + ")";
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .window-container {
        position: fixed;
        z-index: 4;
        left: 100px;
        top: -200px;
    }

</style>